<div class="form-section">
  @if (title()) {
    <div class="form-section-header">
      @if (icon()) {
        <htx-icon class="header-icon" [icon]="icon()"></htx-icon>
      }
      <h2 class="header-title">{{ title() }}</h2>
    </div>
  }

  <div class="form-section-content">
    <ng-content></ng-content>
  </div>
</div>
